export default __webpack_public_path__ + "static/media/jacob-george.eea42b22.jpg";